if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        // Defer DOM lookup to connectedCallback so the button is guaranteed parsed.
        const button = this.querySelector('button');
        if (!button) return;
        this._onClick = (event) => {
          this.expandShowMore(event);
          const parentDisplay = event.target.closest('.parent-display');
          if (!parentDisplay) return;
          const nextElementToFocus = parentDisplay.querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
            const input = nextElementToFocus.querySelector('input');
            if (input) input.focus();
          }
        };
        button.addEventListener('click', this._onClick);
        this._button = button;
      }
      disconnectedCallback() {
        if (this._button && this._onClick) this._button.removeEventListener('click', this._onClick);
      }
      expandShowMore(event) {
        const showMoreHost = event.target.closest('[id^="Show-More-"]');
        if (!showMoreHost) return;
        const parentDisplay = showMoreHost.closest('.parent-display');
        if (!parentDisplay) return;
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
